<template>
  <div class="GDPR">
    <top-page-title>Политика за защита на личните данни</top-page-title>
    <div class="container py-12">
      <div title="Page 1">
        <p>Политика за защита на личните данни на физически лица</p>

        <p>
          В настоящия документ може да намерите Политиката за защита на личните данни на физически лица (&ldquo;Политиката&rdquo;). Тя представлява
          неразделна част от Условията за ползване на сайта и нашите услуги. В случай на промяна на Политиката, промените ще бъдат публикувани тук.
          МПС ЕКСПЕРТ ООД поема ангажимента да защитава предоставените от Вас лични данни в най-висока степен и в пълно съответсвие с регламент (ЕС)
          2016/679. Бихме Ви помолили да отделите нужното време и да се запознаете с долупредставената информация.
        </p>

        <h3>1. Лични данни</h3>
        <h4>1.1С какви цели се събират и обработват личните ми данни?</h4>

        <ul>
          <li>
            Предоставяне на качествени услуги на нашите клиенти
          </li>
          <li>
            Цели, необходими за изпълнение на законови задължения на МПС ЕКСПЕРТ ООД
          </li>
          <li>
            Осъществяване на комункация с Вас, по въпроси, свързани с предлаганите от нас услуги
          </li>
        </ul>

        <h4>1.2 За осъществяване на гореспоменатите цели, какъв вид лични данни се обработват?</h4>
        <table class="table">
          <tbody>
            <tr>
              <td>
                Лични Данни
              </td>
              <td>
                Цел за обработване
              </td>
            </tr>
            <tr>
              <td>
                Имена на потребителя
              </td>
              <td>
                Идентифицира лицето за контакт, към което можем да се обърнем по въпроси свързани с предоставяни услуги, директен маркетинг,
                предоставяне на информация.
              </td>
            </tr>
            <tr>
              <td>
                Телефон
              </td>
              <td
                colspan="1"
                rowspan="2"
              >
                Данните, чрез които осъществяваме връзка с лицето за контакт, с цел осъществяване на целите споменати по-горе, както и връзка за
                комункикация по въпроси свързани със защитата на личните данни на субекта.
              </td>
            </tr>
            <tr>
              <td>
                E-mail
              </td>
            </tr>
          </tbody>
        </table>

        <p>МПС ЕКСПЕРТ ООД не обработва специални категории лични данни.</p>
      </div>
      <div title="Page 2">
        <h3>2. Какъв е срока на съхранение и актуализация?</h3>

        <p>Личните данни се съхраняват в срока, в който могат да послужат на нашите минали, настоящи и бъдещи потенциални клиенти.</p>

        <p>Данните биват актуализирани ежегодно, с цел да не се допуска неточност на данните.</p>
      </div>
      <div title="Page 3">

        <h3>3. Какви са моите права?</h3>

        <p>Субектите на лични данни, обработвани от МПС ЕКСПЕРТ ООД, притежават следните права:</p>

        <h4>3.1. Право на информираност</h4>

        <p>
          При всякакви въпроси относно обработката и защитата на вашите данни, не се колебайте да се
          свържете с нас на contact@mpsexpert.bg.
        </p>

        <h4>3.2. Право на достъп</h4>

        <p>
          Вие имате право да получите потвърждение дали се обработват Ваши лични данни, достъп до тях, както и информация относно обработването им и
          правата Ви относно свързаните с това обработване въпроси. Информация е достъпна в настоящата Политика, а при нужда от допълнителна
          информация, моля вижте по-долу начините за контакт с нас. В случай, че желаете да получите достъп, моля изпратете своето запитване
          на contact@mpsexpert.bg.
        </p>

        <h4>3.3. Право на коригиране</h4>

        <p>
          Вие имате правото да поискате да коригираме Вашите лични данни, в случай, че те са непълни или неточни. При идентифициране на такъв
          проблем, моля свържете се с нас на contact@mpsexpert.bg.
        </p>

        <h4>3.4. Право на изтриване</h4>

        <p> Имате право да поискате изтриване на Вашите данни, освен ако те не са нужни за: </p>
        
        <ul>
          <li>упражняване на правото на свобода на изразяване и правото на информация; </li>
          <li>спазване на правно задължение, изискващо обработване предвидено в правото на Съюза или или правото на държавата членка или по
            причини от обществен интерес в областта на общественото здраве; </li>
          <li>за целите на архивирането в обществен интерес, за научни или исторически изследвания или за статистически цели; </li>
          <li>за упражняване или защита на правни претенции.</li>
        </ul>
        
        <p>
          В случай, че желаете вашите лични данни да бъдат изтрити, моля изпратете своето заявление на contact@mpsexpert.bg.
        </p>

        <h4>3.5. Право на ограничаване на обработването</h4>

        <p>
          Имате правото да изисквате от нас ограничаване на обработването в следните случаи: точността се оспорва за срок, който ни позволява да
          проверим тяхната точност; обработването е неправомерно, но Вие не желаете изтриване, а само тяхното ограничаване на позлване; Ние не се
          нуждаем повече от тях за целите на обработването, но Вие ги изисквате за установяване, упражняването или защита на правни претенции; Вие сте
          възразили срешу обработването на Вашите лични данни, в очакване на проверка дали нашите законни основания имат преимущество пред Вашите
          интереси. В случай, че искате да ограничите обработването на Вашите лични данни, моля изпратете своето заявление на contact@mpsexpert.bg.
        </p>

        <h4>3.6. Право на уведомяване</h4>

        <p>
          Ние уведомяваме за всяко извършено коригиране, изтриване или ограничаване на обработване на Вашите лични данни всеки получател, на когото
          са разкрити личните данни, освен ако това е невъзможно или изисква несъразмерно големи усилия. В случай, че искате да бъдете информирани
          относно получателите, на които се разкриват вашите лични данни, моля изпратете своето заявление на contact@mpsexpert.bg.
        </p>

        <h4>3.7. Право на преносимост</h4>

        <p>
          Вие имате право да получите личните данни, които сте предоставили и които се отнасят за Вас в структуриран, широко използван и пригоден за
          машинно четене формат, както и да използвате тези данни за друг администратор по Ваша преценка. В случай, че искате
          да получите вашите лични данни, моля свържете се с нас на contact@mpsexpert.bg.
        </p>
      </div>
      <div title="Page 5">

        <h4>3.8. Право на възражение</h4>

        <p>
          Вие имате право да възразите по отношение на обработването на лични данни, което е базирано на необходимостта за изпълнение на задача от
          обществен интерес или на необходимостта за целите на легитимните интереси на &ldquo;МПС ЕКСПЕРТ ООД&rdquo; или на трета страна. В случай на
          постъпване на такова възражение, ние ще разгледаме Вашето искане и ако е основателно, ще го изпълним. Ако считаме, че можем да докажем
          съществуването на убедителни законови основания за обработването или че то е необходимо за установяването, упражняването или защитата на
          правни претенции, ще Ви информираме за това. В случай, че искате да упражните правото си на възражение, моля свържете се с нас на
          contact@mpsexpert.bg.
        </p>

        <h4>3.9. Право да не бъдете обект на решение, основаващо се на автоматизирано обработване</h4>

        <p>При предоставяне на услугите и за изпълнение на целите, МПС ЕКСПЕРТ ООД не използва технологии, попадащи в тази категория.</p>

        <h4>3.10. Право на оттегляне на съгласие</h4>

        <p>
          Вие имате право, по всяко време, да оттеглите съгласието си за обработване на лични данни, което е базирано на дадено от Вас съгласие.
          Оттеглянето на съгласието не засяга законосъобразността на обработването, основано на дадено съгласие преди неговото оттегляне. В случай, че
          искате да оттеглите своето съгласие, моля свържете се с нас на contact@mpsexpert.bg.
        </p>

      </div>

      <div title="Page 6">

        <h4>3.11. Право на жалба до наздзорен орган</h4>

        <p>
          Вие имате право да подадете жалба до наздозрен орган, ако считате, че обработването на лични данни, отнасящи се до Вас, нарушава
          приложимото законодателство по защита на личните данни.
        </p>

        <h3>4. Предават ли се данните ми на трети лица?</h3>

        <p>
          МПС ЕКСПЕРТ ООД не предоставя Ваши лични данни на трети лица по никакъв друг начин, освен в описаните в тази Политика и в предвиденитe в
          закона случаи.
        </p>

        <h3>5. Трябва ли да споделям данните си?</h3>

        <p>
          Не сте длъжни да споделяте данните си. Данните Ви ще бъдат съхранени и обработвани само при Вашето изрично съгласие. При желание, винаги
          може да оттеглите Вашето съгласие като се свържете с нас на contact@mpsexpert.bg. Подобно действие ще доведе до преустановяване обработването на Вашите
          лични данни за целите на играта, както и прекратяване на правото Ви да участвате в Платформата МПС Експерт, организирана от МПС Експерт ООД.
        </p>

        <h3>6. Как може да се свържа с Вас по въпроси, свързани с обработката на моите данни?</h3>

        <p>За контакти с нас - МПС ЕКСПЕРТ ООД, можете да се обърнете на e-mail: contact@mpsexpert.bg</p>

        <p>
          Ако смятате, че действаме в противоречие с текущите правила или имате въпроси относно тях, моля, свържете се с нас на посочения по-горе
           e-mail адрес за контакт. В случай на неизправност, имате правото да подадете официална жалба и на органа за защита на личните данни.
        </p>

      </div>
      <div title="Page 7">

        <h3>7. Актуализация на настоящата политика за защита на личните данни</h3>

        <p>
          В случай на съществена промяна в настоящите правила, за да защитим Вашите права и свободи, ще положим всички разумни усилия, за да Ви
          информираме най-малко 14 календарни дни преди извършването ѝ.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @module GDPR
 */
export default {
  name: 'GDPR'
}
</script>

<style lang='scss' scoped>
@import '~utils';

p {
  margin-bottom: 1rem;
}

table {
  margin-bottom: 1em;
}

table, td {
  border: 1px solid black
}

td {
  padding: 1em;
}

ul {
  margin-bottom: 1em;
}

h3, h4 {
  margin-bottom: 1em;
}
</style>
